import { Box, Text, Flex, Image, SimpleGrid, Stack } from '@chakra-ui/react'

import imgHome1 from '../../../assets/img/home/home2/FotoswebsiteTMG-01.png';
import imgHome2 from '../../../assets/img/home/home2/FotoswebsiteTMG-02.png';
import imgHome3 from '../../../assets/img/home/home2/FotoswebsiteTMG-03.png';
import imgHome4 from '../../../assets/img/home/home2/FotoswebsiteTMG-04.png';
import imgHome5 from '../../../assets/img/home/home2/FotoswebsiteTMG-05.png';
import { useTranslation } from 'react-i18next';
import { useMediaQuery } from '@chakra-ui/react';

function ServicesCarousel() {
    const { t } = useTranslation();

    const [isTabletLandscape] = useMediaQuery(
        '(min-width: 1024px) and (max-width: 1279px)'
    );


    return (

        <SimpleGrid columns={{ base: 1, md: 3 }} gap={6}
            mt={'3%'}
            paddingLeft={{ base: '5%', md: '0%' }}
        >

            <Box>
                <Flex direction="column"
                    w="100%"
                    justifyContent="center"
                    p={{ base: "1%", md: "1%", lg: "1%" }}
                >
                    <Box
                        boxSize={
                            isTabletLandscape ? "280px" : { base: "340px", md: "250px", lg: "390px" }
                        }
                        mx="auto"
                        overflow="hidden"
                        display="flex"
                        justifyContent="center"
                        alignItems="center"
                    >
                        <Image
                            src={imgHome1}
                            w={{ base: "90%", md: "90%", lg: "100%" }}
                            h={{ base: "220px", md: "90%", lg: "80%" }}
                            objectFit="cover"
                            objectPosition="center"
                            borderRadius="30px"
                            filter="grayscale(100%)"
                            transition="all 0.4s ease-in-out"
                            _hover={{ filter: "grayscale(0%)", transform: "scale(1.03)" }}
                        />
                    </Box>

                    <Text color="#ae8245" fontFamily="Inter" fontWeight="heavy" fontSize="120%">
                        {t("title-image1")}
                    </Text>

                    <Text color="#FFFFFF" fontFamily="Inter" fontWeight="light" w="100%">
                        {t("title-info1")}
                    </Text>
                </Flex>
            </Box>

            <Box>
                <Flex direction="column" w="100%"
                    justifyContent="center"
                    p={{ base: "1%", md: "1%", lg: "1%" }}
                >
                    <Box
                        boxSize={
                            isTabletLandscape ? "280px" : { base: "340px", md: "250px", lg: "390px" }
                        }
                        w="100%"
                        maxW="420px"
                        mx="auto"
                        display="flex"
                        justifyContent="center"
                        alignItems="center"
                        borderRadius="30px"
                    >
                        <Image
                            src={imgHome2}
                            w={{ base: "80%", md: "90%", lg: "100%" }}
                            h={{ base: "220px", md: "90%", lg: "80%" }}
                            objectFit="cover"
                            objectPosition="right"
                            borderRadius="30px"
                            filter="grayscale(100%)"
                            transition="all 0.4s ease-in-out"
                            _hover={{ filter: "grayscale(0%)", transform: "scale(1.03)" }}
                        />
                    </Box>

                    <Text color="#ae8245" fontFamily="Inter" fontWeight="heavy" textAlign="justify" fontSize="120%">
                        {t("title-image2")}
                    </Text>

                    <Text color="#FFFFFF" fontFamily="Inter" fontWeight="light" w="100%">
                        {t("title-info2")}
                    </Text>
                </Flex>
            </Box>

            <Box>
                <Flex direction="column" w="100%"
                    justifyContent="center"
                    p={{ base: "1%", md: "1%", lg: "1%" }}
                >
                    <Box
                        boxSize={
                            isTabletLandscape ? "280px" : { base: "340px", md: "250px", lg: "390px" }
                        }
                        w="100%"
                        maxW="420px"
                        mx="auto"
                        overflow="hidden"
                        display="flex"
                        justifyContent="center"
                        alignItems="center"
                        borderRadius="30px"
                    >
                        <Image
                            src={imgHome3}
                            w={{ base: "80%", md: "90%", lg: "100%" }}
                            h={{ base: "220px", md: "90%", lg: "80%" }}
                            borderRadius="30px"
                            filter="grayscale(100%)"
                            transition="all 0.4s ease-in-out"
                            _hover={{ filter: "grayscale(0%)", transform: "scale(1.03)" }}
                        />
                    </Box>

                    <Text color="#ae8245" fontFamily="Inter" fontWeight="heavy" fontSize="120%">
                        {t("title-image3")}
                    </Text>

                    <Text color="#FFFFFF" fontFamily="Inter" fontWeight="light" w="100%">
                        {t("title-info3")}
                    </Text>
                </Flex>
            </Box>

            <Box
                gridColumn={{ base: "auto", md: "1 / span 3" }}
                display="block"
                w="100%"
            >
                <Stack
                    direction={{ base: "column", md: "row" }}
                    spacing={{ base: 4, md: '5%' }}
                    justifyContent="center"
                    alignItems="center"
                >
                    {/* ITEM 4 */}
                    <Box w={{ base: "100%", md: "30%" }}
                        maxW={{ base: "100%", md: "420px" }}
                    >
                        <Flex direction="column"
                            w="100%"
                            justifyContent="center"
                            p={{ base: "1%", md: "7%", lg: "1%" }}

                        >
                            <Box
                                boxSize={
                                    isTabletLandscape ? "280px" : { base: "340px", md: "250px", lg: "390px" }
                                }
                                w="100%"
                                maxW="420px"
                                mx="auto"
                                overflow="hidden"
                                display="flex"
                                justifyContent="center"
                                alignItems="center"
                            >
                                <Image
                                    src={imgHome4}
                                    w={{ base: "80%", md: "90%", lg: "100%" }}
                                    h={{ base: "220px", md: "90%", lg: "80%" }}
                                    objectFit="cover"
                                    objectPosition="center"
                                    borderRadius="30px"
                                    filter="grayscale(100%)"
                                    transition="all 0.4s ease-in-out"
                                    _hover={{ filter: "grayscale(0%)", transform: "scale(1.03)" }}
                                />
                            </Box>

                            <Text color="#ae8245" fontFamily="Inter" fontWeight="heavy" w={'100%'} fontSize="120%">
                                {t("title-image4")}
                            </Text>

                            <Text color="#FFFFFF" fontFamily="Inter" fontWeight="light" w="100%">
                                {t("title-info4")}
                            </Text>
                        </Flex>
                    </Box>

                    {/* ITEM 5 */}
                    <Box w={{ base: "100%", md: "30%" }}
                        maxW={{ base: "100%", md: "420px" }}
                    >
                        <Flex direction="column"
                            w="100%"
                            justifyContent="center"
                            p={{ base: "1%", md: "7%", lg: "1%" }}

                        >
                            <Box
                                boxSize={
                                    isTabletLandscape ? "280px" : { base: "340px", md: "250px", lg: "390px" }
                                }
                                w="100%"
                                maxW="420px"
                                mx="auto"
                                overflow="hidden"
                                display="flex"
                                justifyContent="center"
                                alignItems="center"
                            >
                                <Image
                                    src={imgHome5}
                                    w={{ base: "80%", md: "90%", lg: "100%" }}
                                    h={{ base: "220px", md: "90%", lg: "80%" }}
                                    objectFit="cover"
                                    objectPosition="center"
                                    borderRadius="30px"
                                    filter="grayscale(100%)"
                                    transition="all 0.4s ease-in-out"
                                    _hover={{ filter: "grayscale(0%)", transform: "scale(1.03)" }}
                                />
                            </Box>

                            <Text color="#ae8245" fontFamily="Inter" fontWeight="heavy" fontSize="120%">
                                {t("title-image5")}
                            </Text>

                            <Text color="#FFFFFF" fontFamily="Inter" fontWeight="light" w="100%">
                                {t("title-info5")}
                            </Text>
                        </Flex>
                    </Box>
                </Stack>
            </Box>
        </SimpleGrid>





    )
}

export default ServicesCarousel
